import React from "react";
import Activities from "../../components/Activities";
import {Box} from "@mui/material";
import Social from "../../components/Social";
import {styled} from "@mui/material/styles";
import { FetchActivities } from "../../components/Activities/FetchActivities";

const HomeWrapper = styled(Box)(
	({ theme }) => `
	display: flex;
	flex: 1;
    background: ${theme.palette.background.default};
    height: 100%;
    width: 100%;
    padding: ${theme.spacing(2)} 0 0 0;
`
);

const ContentBox = styled(Box)(
	({ theme }) => `
	padding: 0 ${theme.spacing(1)} ${theme.spacing(1)} 0;
	min-width: ${theme.sidebar.width};
	flex: 1;
	height: 100%;
`
);
const ContentBoxInner = styled(Box)(
	({ theme }) => `
	flex: 1;
	height: 100%;
`
);

const FixedWidthBox = styled(Box)(
	({ theme }) => `
	min-width: ${theme.sidebar.width};
	width: ${theme.sidebar.width};
	padding-right: ${theme.spacing(1)};
`
);

export default function HomeLayout({ children }) {
	return (
		<HomeWrapper id={"HomeWrapper"}>
			<FixedWidthBox>
				<FetchActivities/>
			</FixedWidthBox>
			<ContentBox>
				<ContentBoxInner>
					{children}
				</ContentBoxInner>
			</ContentBox>
			<FixedWidthBox>
				<Social />
			</FixedWidthBox>
		</HomeWrapper>
	);
}
